import ProgramOutline1 from '../assets/images/program-outline-1.jpg'
import ProgramOutline2 from '../assets/images/program-outline-2.jpg'

function ProgramOutline() {
    return (
        <div>
            <div className='general_flex_box'>
                <h2 className="general_align_left">Program Outline</h2>
                <p className="general_align_right"><strong>Venue: Curtin Singapore</strong></p>
            </div>

            <div className='general_flex_box'>
                <div className="general_align_left">
                    <h4><strong>IETBHEC’26 (05 - 07 July 2026)</strong></h4>
                    <h4><strong>Preliminary Conference Program</strong></h4>
                    <h4>(subject to change)</h4>
                </div>

                <table border="1" cellspacing="0" cellpadding="8" id="outline-table-right">
                <tbody>
                    <tr className="outline-table-color1">
                        <td className="no-line-break">Day 1</td>
                        <td>Pre Conference Masterclasses (Workshops)</td>
                    </tr>
                    <tr className="outline-table-color2">
                        <td className="no-line-break">Day 2</td>
                        <td>Registration, Inaugural, welcome, Opening Address, Keynotes, Paper Presentations & Panel Sessions</td>
                    </tr>
                    <tr className="outline-table-color3">
                        <td className="no-line-break">Day 3</td>
                        <td>Keynotes, Paper Presentations, Panel Sessions & Conference Gala Banquet</td>
                    </tr>
                </tbody>
                </table>
            </div>
        
            <br></br>

            <table border="1" className="outline-table">
                <caption><strong>SUNDAY, July 5, 2026</strong></caption>
                <tbody>
                    <tr>
                        <td className="no-line-break outline-table-td-left">10:00 am – 12:00 pm</td>
                        <td className="gray-background">Pre Conference Masterclasses (Workshops) <br></br> Venue: TBA</td>
                    </tr>
                    <tr>
                        <td>12:00 pm – 01:00 pm</td>
                        <td>Lunch</td>
                    </tr>
                </tbody>
            </table>

            <table border="1" cellspacing="0" cellpadding="8" className="outline-table">
                <caption><strong>MONDAY, July 6, 2026</strong></caption>
                <tbody>
                    <tr>
                        <td className="no-line-break outline-table-td-left">08:00 am – 09:00 am</td>
                        <td className="gray-background">Registration</td>
                    </tr>
                    <tr>
                        <td className="no-line-break outline-table-td-left">09:00 am – 09:15 am</td>
                        <td>Opening Ceremony Inaugural and Welcome Address</td>
                    </tr>
                    <tr>
                        <td className="no-line-break outline-table-td-left">09:15 am – 10:00 am</td>
                        <td className="outline-table-color6">Academic Keynote Address</td>
                    </tr>
                    <tr>
                        <td className="no-line-break outline-table-td-left">10:00 am – 10:45 am</td>
                        <td className="outline-table-color7">Industry Keynote Address</td>
                    </tr>
                    <tr>
                        <td className="no-line-break">10:45 am – 11:15 am</td>
                        <td className="gray-background">Morning Tea</td>
                    </tr>
                    <tr>
                        <td className="no-line-break">11:15 am – 01:00 pm</td>
                        <td>
                            <table className="border-right multi-columns-full-width">
                            <tr>
                                <td className="outline-table-color5">Breakout Session (MP1)</td>
                                <td className="outline-table-color2">Breakout Session (MP2)</td>
                                <td className="outline-table-color3">Breakout Session (MP3)</td>
                            </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td className="no-line-break">01:00 pm – 02:00 pm</td>
                        <td className="gray-background">Lunch Break</td>
                    </tr>
                    <tr>
                        <td className="no-line-break">02:00 pm – 03:15 pm</td>
                        <td>
                            <table className="border-right multi-columns-full-width">
                            <tr>
                                <td className="outline-table-color1">Breakout Session (MP4)</td>
                                <td className="outline-table-color2">Breakout Session (MP5)</td>
                                <td className="outline-table-color3">Breakout Session (MP6)</td>
                            </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td className="no-line-break">03:15 pm – 03:45 pm</td>
                        <td className="gray-background">Afternoon Tea</td>
                    </tr>
                    <tr>
                        <td className="no-line-break">03:45 pm – 04:45 pm</td>
                        <td className="outline-table-color8">Special Panel Session: Conversation with Academia</td>
                    </tr>
                    <tr>
                        <td className="no-line-break">04:45 pm – 05:00 pm</td>
                        <td className="outline-table-color7">Close of Day 1</td>
                    </tr>
                    <tr>
                        <td className="no-line-break">06:00 pm – 08:30 pm</td>
                        <td>IETBHEC Organising Committee Meeting and Dinner (by invitation ONLY)</td>
                    </tr>
                </tbody>
            </table>
            
            <table border="1" cellspacing="0" cellpadding="5" className="outline-table">
                <caption><strong>TUESDAY, July 7, 2026</strong></caption>
                <tbody>
                    <tr>
                        <td className="no-line-break outline-table-td-left">08:30 am – 09:15 am</td>
                        <td className="gray-background">Registration</td>
                    </tr>
                    <tr>
                        <td className="no-line-break">09:15 am – 10:00 am</td>
                        <td className="outline-table-color6">Academic Keynote Address</td>
                    </tr>
                    <tr>
                        <td className="no-line-break">10:00 am – 10:45 am</td>
                        <td className="outline-table-color7">Industry Keynote Address</td>
                    </tr>
                    <tr>
                        <td className="no-line-break">10:45 am – 11:15 am</td>
                        <td className="gray-background">Morning Tea</td>
                    </tr>
                    <tr>
                    <td className="no-line-break">11:15 am – 01:00 pm</td>
                    <td>
                        <table className="border-right multi-columns-full-width">
                            <tr>
                                <td className="outline-table-color1">Breakout Session (MP1)</td>
                                <td className="outline-table-color2">Breakout Session (MP2)</td>
                                <td className="outline-table-color3">Breakout Session (MP3)</td>
                            </tr>
                        </table>
                    </td>
                    </tr>
                    <tr>
                        <td className="no-line-break">01:00 pm – 02:00 pm</td>
                        <td className="gray-background">Lunch Break</td>
                    </tr>
                    <tr>
                    <td className="no-line-break">02:00 am – 03:15 pm</td>
                    <td>
                        <table className="border-right multi-columns-full-width">
                            <tr>
                                <td className="outline-table-color1">Breakout Session (MP4)</td>
                                <td className="outline-table-color2">Breakout Session (MP5)</td>
                                <td className="outline-table-color3">Breakout Session (MP6)</td>
                            </tr>
                        </table>
                    </td>
                    </tr>
                    <tr>
                        <td className="no-line-break">03:15 pm – 03:45 pm</td>
                        <td className="gray-background">Afternoon Tea</td>
                    </tr>
                    <tr>
                        <td className="no-line-break">03:45 pm – 04:45 pm</td>
                        <td className="outline-table-color1">Special Panel Session: Conversation with Industry</td>
                    </tr>
                    <tr>
                        <td className="no-line-break">04:45 pm – 05:30 pm</td>
                        <td className="outline-table-color5">Closing Ceremony</td>
                    </tr>
                    <tr>
                        <td className="no-line-break">07:00 pm – 10:00 pm</td>
                        <td className="outline-table-color7">Conference Gala Banquet and Award Ceremony</td>
                    </tr>
                </tbody>
            </table>
            
            {/* <table border="1" cellspacing="0" cellpadding="5" className="outline-table">
                <caption><strong>WEDNESDAY, November 26, 2025</strong></caption>
                <tbody>
                    <tr>
                    <td className="no-line-break outline-table-td-left">8:30 am – 9:00 am</td>
                    <td className="gray-background">Registration</td>
                    </tr>
                    <tr>
                    <td className="no-line-break">9:00 am – 10:00 am</td>
                    <td>
                        Keynote Address 3<br></br>
                        (Venue: TBA)
                    </td>
                    </tr>
                    <tr>
                    <td className="no-line-break">10:00 am – 10:30 am</td>
                    <td className="gray-background">Morning Tea</td>
                    </tr>
                    <tr>
                    <td className="no-line-break">10:30 am – 13:00 pm</td>
                    <td className="outline-table-color2">Conversation with Industry: Special Panel Session (WP1)</td>
                    </tr>
                    <tr>
                    <td className="no-line-break">13:00 pm – 13:30 pm</td>
                    <td className="gray-background">Refreshment Break</td>
                    </tr>
                    <tr>
                    <td className="no-line-break">13:30 pm – 14:00 pm</td>
                    <td className="outline-table-color1">Closing Ceremony</td>
                    </tr>
                </tbody>
            </table> */}

        </div>
    )
}

export default ProgramOutline